<div class="workgroup-flex">
  <label style="margin-bottom: 5px" *ngIf="label">
    {{ label }}
    <span *ngIf="required" class="required-asterisk">*</span>
  </label>
  <div
    class="iholder"
    [matMenuTriggerFor]="menu"
    [ngClass]="{ disabled: !editable }"
  >
  <button mat-icon-button>
    <mat-icon style="margin-right: 0.5rem;">hub</mat-icon>
  </button>
  </div>
</div>

<mat-menu #menu="matMenu" class="my-menu">
  <div (click)="$event.stopPropagation()" *ngIf="pi">
    <form class="example-form">
      <mat-form-field class="example-full-width" style="width: 100%">
        <input
          type="text"
          placeholder="Search PI"
          matInput
          [formControl]="myControl"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="addPI($event.option.value)"
        >
          <mat-option
            *ngFor="let option of filteredOptions | async"
            [value]="option"
          >
            <b>{{ option.name }}</b> <br />
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </form>

    <div class="selected-holder">
      <div
        *ngFor="let sel of selectedPI; let i = index"
        class="selected-item"
      >
        <div>
          <span style="font-weight: 700">{{ sel.name }}</span> <br />
        </div>
        <button
          mat-icon-button
          color="warn"
          (click)="removePI(i)"
          class="small-icon-button"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
</mat-menu>
